import { AxiosInstance } from "axios";
import axios from "axios";
import * as moment from "moment";

import { IAllFilters, IUrl } from "src/views/Links/types";
import { IProfile } from "src/views/Admin/Profiles/types";

import createQuery from "./utils/createQuery";

const toResponse = (
  response: any,
  markets: IProfile[],
  linksPerPage: number,
  marketParameterName: string
) => {
  if (!response.success || !response.result || !response.result.hits) {
    throw new Error(
      `Response failed with code ${response.statusCode}: ${response.errorMessage}`
    );
  }

  const links = response.result.hits.hits.map((el: any) => {
    const data = el._source;
    const linkParameters = data.parameters.map((p: any) => ({
      name: p.Name,
      value: p.Value,
      group: p.ParameterGroup || "GeneralInformation",
    }));

    const foundMarket = markets.find(
      (market) => market.id === Number(data.MarketId)
    );

    linkParameters.unshift({
      name: marketParameterName,
      value: foundMarket && foundMarket.name,
      group: "GeneralInformation",
    });

    return {
      id: data.id,
      visibleId: data.UniqueLinkId,
      creatorEmail: data.CreatorEmail,
      created: moment(data.CreatedOn).utc().format("DD.MM.YYYY H:mm"),
      parameters: linkParameters,
      urls: data.urls
        .map(
          (url: any): IUrl => ({
            id: url.id,
            url: url.Url,
            displayName: url.UrlProfileDisplayName,
            shortUrl: url.ShortUrl,
            canShorten: url.CanShorten,
            canCopy: url.CanCopy,
            isMain: url.IsMainUrl,
            showQR: url.ShowQrCode,
          })
        )
        .sort((a: IUrl, b: IUrl) => {
          if ((a.isMain && b.isMain) || (!a.isMain && !b.isMain)) {
            return 0;
          }
          return a.isMain && !b.isMain ? -1 : 1;
        }),
    };
  });

  return {
    links,
    pageCount: Math.ceil(response.result.hits.total / linksPerPage),
  };
};

export default (api: AxiosInstance, url: string) =>
  (options: IAllFilters, markets: IProfile[], marketParameterName: string) => {
    const cancel = axios.CancelToken;
    const source = cancel.source();
    return {
      getData: async () => {
        const response = await api.post(url, createQuery(options), {
          cancelToken: source.token,
        });
        if (!response) {
          return Promise.reject();
        }
        return toResponse(
          response.data,
          markets,
          options.linksPerPage,
          marketParameterName
        );
      },
      cancel: source.cancel,
    };
  };



// WEBPACK FOOTER //
// ./src/services/api/links/getArchive.ts